<template>
  <div>
    <div v-for="pepper in pepperTransformations"
         class="pepper"
         :style="'left: ' + pepper.x + 'vw; top: ' + pepper.y + 'vh; ' +
            'transform: scale('+ pepper.scale +') rotate('+ pepper.rotate +'deg) scaleX('+ pepper.scaleX +');' +
            'filter: blur(5px); z-index: -1'"
         v-bind:key="pepper.id"
    >
      <LogoElement></LogoElement>
    </div>
  </div>
</template>

<script>
    import LogoElement from '@shared/components/LogoElement'

    export default {
    name: 'PeppersBackground',
    components: { LogoElement },
    data() {
      return {
        pepperTransformations: [
          { x: 80, y: 10, rotate: 5, scale: 3, scaleX: 1 },
          { x: 0, y: 30, rotate: 5, scale: 4, scaleX: -1 },
          { x: 70, y: 40, rotate: 45, scale: 1.6, scaleX: 1 },
          { x: 30, y: 55, rotate: 90, scale: 2, scaleX: 1 },
          { x: 70, y: 60, rotate: 0, scale: 0.7, scaleX: 1 },
          { x: 20, y: 70, rotate: 0, scale: 1.2, scaleX: -1 },
          { x: 70, y: 80, rotate: 0, scale: 3, scaleX: -1 }
        ]
      }
    }
  }
</script>

<style scoped>
.pepper {
  position: absolute;
}
</style>
